import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Icon } from '@/components/ui/icon';
import { Alert02Icon } from '@/components/ui/icon/glyphs';
import { NudgeMatchRow, type NudgeMatchRowData } from './nudge-match-row';
const MAX_MATCHES = 3;
export interface NudgeMatchesProps {
  readonly matches: ReadonlyArray<NudgeMatchRowData>;
  readonly onDismiss?: () => void;
}
export function NudgeMatches(t0) {
  const $ = _c(31);
  const {
    matches,
    onDismiss
  } = t0;
  const t = useTranslations("launchpad.duplicateNudge");
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== matches || $[1] !== t) {
    const visible = matches.slice(0, MAX_MATCHES);
    t3 = "flex flex-col gap-3 rounded-panel-row border border-feedback-warning-border bg-feedback-warning-surface px-4 py-3";
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="flex size-7 shrink-0 items-center justify-center rounded-full bg-feedback-warning-accent"><Icon icon={Alert02Icon} className="size-4 text-white" /></div>;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    let t6;
    if ($[7] !== t) {
      t6 = t("title");
      $[7] = t;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    let t7;
    if ($[9] !== t6) {
      t7 = <span className="text-caption font-semibold text-feedback-warning-content">{t6}</span>;
      $[9] = t6;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    const t8 = <div className="flex flex-col gap-0.5">{t7}<span className="text-micro text-foreground-secondary">{t("subtitle", {
          count: visible.length
        })}</span></div>;
    if ($[11] !== t8) {
      t4 = <div className="flex items-start gap-3">{t5}{t8}</div>;
      $[11] = t8;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    t1 = "flex flex-col gap-2";
    t2 = visible.map(_temp);
    $[0] = matches;
    $[1] = t;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[13] !== t1 || $[14] !== t2) {
    t5 = <div className={t1}>{t2}</div>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== onDismiss || $[17] !== t) {
    t6 = onDismiss !== undefined ? <button type="button" onClick={onDismiss} className="text-micro font-semibold text-foreground-secondary hover:text-foreground-primary">{t("dismiss")}</button> : <span />;
    $[16] = onDismiss;
    $[17] = t;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t) {
    t7 = t("stillContinue");
    $[19] = t;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t7) {
    t8 = <span className="text-micro text-foreground-secondary">{t7}</span>;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t6 || $[24] !== t8) {
    t9 = <div className="flex items-center justify-between border-t pt-2">{t6}{t8}</div>;
    $[23] = t6;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t3 || $[27] !== t4 || $[28] !== t5 || $[29] !== t9) {
    t10 = <div className={t3}>{t4}{t5}{t9}</div>;
    $[26] = t3;
    $[27] = t4;
    $[28] = t5;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  return t10;
}
function _temp(m) {
  return <NudgeMatchRow key={m.pubkey} match={m} />;
}